import { PrivateRouteProps } from 'navigation/router/components/routes/private-route';
import { Role } from 'features/auth/types';
import {
  PatientAndClinicianRoutes,
  PatientOnboardingRoutes,
  PatientOnlyRoutes_DOES_NOT_NEED_ASSESSMENT,
  PATIENT_IN_ASSESSMENT_ROUTES,
  PATIENT_NEEDS_ASSESSMENT_ROUTES
} from '../../config/routes-patient/routes-patient-patientId';

export const IS_ONBOARDING = 0b001;
export const NEEDS_ASSESSMENT = 0b010;
export const IS_IN_ASSESSMENT = 0b100;

const BITMASK_MAP: Record<number, PrivateRouteProps[]> = {
  [IS_ONBOARDING]: PatientOnboardingRoutes,
  [IS_ONBOARDING | NEEDS_ASSESSMENT]: [...PatientOnboardingRoutes],
  [NEEDS_ASSESSMENT]: PATIENT_NEEDS_ASSESSMENT_ROUTES,
  [IS_IN_ASSESSMENT]: PATIENT_IN_ASSESSMENT_ROUTES,
  [0b00]: [...PatientOnlyRoutes_DOES_NOT_NEED_ASSESSMENT]
};

interface FilterPatientRoutesArgs {
  role: Role;
  options:
    | {
        useBitmask: false;
        userIsBeingOnboarded: boolean;
        userIsDoingAnAssessment: boolean;
        userNeedsAnAssessment: boolean;
      }
    | { useBitmask: true; bitmask: number };
}

/**
 * User states
 * - The user is a clinician or clinic admin (0b000)
 * - The user is a patient that needs to complete their onboarding (0b110)
 * - The user is a patient that has completed their onboarding and needs to do an assessment (0b101)
 * - The user is a patient that has completed their onboarding and has started an assessment (0b101)
 * - The user is a patient that has completed their onboarding and does not need to do an assessment (0b100)
 */
export function filterPatientRoutes(args: FilterPatientRoutesArgs) {
  if ([Role.Clinician, Role.ClinicAdmin].includes(args.role))
    return PatientAndClinicianRoutes;
  let mask = 0;

  if (!args.options.useBitmask) {
    if (args.options.userIsBeingOnboarded) mask |= IS_ONBOARDING;
    if (args.options.userIsDoingAnAssessment) mask |= IS_IN_ASSESSMENT;
    if (args.options.userNeedsAnAssessment) mask |= NEEDS_ASSESSMENT;
  } else {
    mask = args.options.bitmask;
  }

  /**
   * Validate that this is a valid mask
   */
  if (!(mask in BITMASK_MAP)) {
    throw new Error(
      `[filterPatientRoutes] Invalid mask. Mask '0b${mask.toString(
        2
      )}' is not mapped in '${Object.keys(BITMASK_MAP).map(
        _ => `0b${parseInt(_).toString(2)}`
      )}'`
    );
  }

  return BITMASK_MAP[mask];
}
